import React, { useState } from "react";
import CloseIcon from "@styles/all-images/icons/closeblack.svg";
// import BackIcon from "@styles/all-images/icons/back-button.svg";

interface StaffManagementEditCardProps {
  onClose: () => void;
  onSubmit: () => void;
}

const StaffManagementEditCard = ({
  onClose,
  onSubmit,
}: StaffManagementEditCardProps) => {
  const profiles = [
    { id: 1, name: "Profile 1", checked: true },
    { id: 2, name: "Profile 2", checked: true },
    { id: 3, name: "Profile 3", checked: false },
    { id: 4, name: "Profile 4", checked: false },
  ];
  return (
    <div>
      <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
        <div className="tw-bg-white tw-rounded-2xl tw-w-80 tw-p-6">
          <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
            <div></div>
            <h2 className="tw-text-lg font-weight-semibold font-primary-color ">
              Edit Profile
            </h2>
            <button
              onClick={onClose}
              className="tw-text-gray-500 tw-hover:text-gray-700"
            >
              <img src={CloseIcon} alt="Close Icon" className="tw-w-5 tw-h-5" />
            </button>
          </div>

          <div className="tw-space-y-4 tw-mb-6">
            {profiles.map((profile) => (
              <label
                key={profile.id}
                className="tw-flex tw-items-center tw-space-x-3"
              >
                <input
                  type="checkbox"
                  defaultChecked={profile.checked}
                  className="tw-w-4 tw-h-4 tw-rounded tw-border-gray-300"
                />
                <span className="tw-text-sm font-weight-base font-primary-color">
                  {profile.name}
                </span>
              </label>
            ))}
          </div>

          <div className="tw-flex tw-space-x-4">
            <button
              onClick={onClose}
              className="tw-flex-1 tw-px-4 tw-py-2 tw-border font-default-primary-color tw-border-[#146C94] tw-rounded-lg tw-w-[50%] tw-text-center"
            >
              Cancel
            </button>
            <button
              onClick={onSubmit}
              className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-2 tw-w-[50%] tw-justify-center tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffManagementEditCard;
